import React, {
    useState,
    useEffect
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    useNavigate
} from 'react-router-dom';

import Swal
    from 'sweetalert2';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';

import useConfigAuth
    from '../../Hooks/useConfigAuth';


import {
    solicitarAnamnesisAction
} from '../../actions/solicitarAnamnesisActions';

import {
    objetivosSolicitarAction
} from '../../actions/objetivosActions';

import {
    historiaClinicaSolicitarAction
} from '../../actions/historiaClinicaActions';

import {
    actividadesSolicitarAction,
    actividadesAgendadasSolicitarAction
} from '../../actions/actividadesActions';

import {
    solicitoCantidadSuscripcionAction
} from '../../actions/cargarSuscripcionActions';

import {
    modificoPacienteLecturaAction,
    modificoPacienteMinusculaAction
} from '../../actions/configuradorActions';


// CSS
import {
    Cuerpo
} from '../Css/StyledHeader';


import {

    PaginaPaciente,

    GridPaciente,
    ColumnaResumen,

    TarjetaPaciente,
    CabeceraTarjetaPaciente,
    BloqueTituloPaciente,
    TituloTarjetaPaciente,
    TextoTarjetaPaciente,

    BotonEditarPaciente,
    BotonEditarPacienteDeshabilitado,

    DatosPaciente,
    DatoPaciente,
    LabelDatoPaciente,
    ValorDatoPaciente,

    BloqueInvitacion,
    CabeceraInvitacion,
    TituloInvitacion,
    EstadoInvitacion,
    EmailInvitacion,
    TextoInvitacion,
    VigenciaInvitacion,

    SeparadorPaciente,

    BotonMetodo,
    BotonMetodoLink,

    ConfiguracionInferior,
    ConfiguracionInlineItem,
    ConfiguracionInlineLabel,
    BotonConfiguracion,

    GridAccesos,
    BotonAcceso,
    BotonAccesoLink,
    AccesoAncho,

    AvisoMetodo,
    TextoNoSuscripto

} from '../Css/StyledPacienteResumen';


/*
========================================
ESTADO VISUAL DE INVITACIÓN
========================================
*/

const obtenerEstadoInvitacion = ({

    paciente_id,
    estado_email_invitacion,
    t_inv_restante

}) => {

    /*
    ========================================
    CUENTA YA CREADA
    ========================================
    */

    if (
        paciente_id !== null &&
        paciente_id !== undefined
    ) {

        return {

            tipo:
                'exito',

            etiqueta:
                'Cuenta creada',

            detalle:
                'El paciente ya tiene una cuenta creada y vinculada.',

            email:
                null,

            mostrarVigencia:
                false

        };

    }


    /*
    ========================================
    NUNCA SE ENVIÓ
    ========================================
    */

    if (
        !estado_email_invitacion
    ) {

        return {

            tipo:
                'neutral',

            etiqueta:
                'No enviada',

            detalle:
                'Todavía no hay una invitación enviada a este paciente.',

            email:
                null,

            mostrarVigencia:
                false

        };

    }


    const estado =
        String(
            estado_email_invitacion.estado ||
            ''
        )
            .trim()
            .toUpperCase();


    const errorCode =
        String(
            estado_email_invitacion.error_code ||
            ''
        )
            .trim()
            .toUpperCase();


    const email =
        estado_email_invitacion.email ||
        null;


    /*
    ========================================
    SPAM
    ========================================
    */

    if (
        estado ===
        'SPAM'
    ) {

        return {

            tipo:
                'error',

            etiqueta:
                'Marcado como spam',

            detalle:
                'El destinatario marcó este correo como spam. Conviene contactarlo por otro medio antes de volver a enviar una invitación.',

            email,

            mostrarVigencia:
                false

        };

    }


    /*
    ========================================
    REBOTADO / RECHAZADO
    ========================================
    */

    if (
        estado ===
        'REBOTADO' ||

        estado ===
        'RECHAZADO'
    ) {

        return {

            tipo:
                'error',

            etiqueta:
                'Email rechazado',

            detalle:
                'El servidor de destino rechazó el email. Revisá que la dirección cargada sea correcta antes de volver a enviarlo.',

            email,

            mostrarVigencia:
                false

        };

    }


    /*
    ========================================
    ERROR
    ========================================
    */

    if (
        estado ===
        'ERROR'
    ) {

        if (
            errorCode ===
            'EMAIL_INVALIDO'
        ) {

            return {

                tipo:
                    'error',

                etiqueta:
                    'Email inválido',

                detalle:
                    'La dirección de email no tiene un formato válido. Revisala antes de volver a enviar la invitación.',

                email,

                mostrarVigencia:
                    false

            };

        }


        if (
            errorCode ===
            'EMAIL_RECHAZADO'
        ) {

            return {

                tipo:
                    'error',

                etiqueta:
                    'Email rechazado',

                detalle:
                    'El servidor de destino rechazó el email. Revisá que la dirección cargada sea correcta.',

                email,

                mostrarVigencia:
                    false

            };

        }


        return {

            tipo:
                'error',

            etiqueta:
                'Error de envío',

            detalle:
                'No se pudo completar el envío de la invitación. Podés revisar el email cargado y volver a intentarlo.',

            email,

            mostrarVigencia:
                false

        };

    }


    /*
    ========================================
    REINTENTO
    ========================================
    */

    if (
        estado ===
        'REINTENTO_PENDIENTE'
    ) {

        return {

            tipo:
                'advertencia',

            etiqueta:
                'Reintentando envío',

            detalle:
                'El primer intento tuvo un inconveniente y YÖGEN realizará un nuevo intento automáticamente.',

            email,

            mostrarVigencia:
                Boolean(
                    t_inv_restante
                )

        };

    }


    /*
    ========================================
    DEMORADO
    ========================================
    */

    if (
        estado ===
        'DEMORADO'
    ) {

        return {

            tipo:
                'advertencia',

            etiqueta:
                'Entrega demorada',

            detalle:
                'El servidor de destino informó una demora. El email todavía puede ser entregado.',

            email,

            mostrarVigencia:
                Boolean(
                    t_inv_restante
                )

        };

    }


    /*
    ========================================
    ENTREGADO
    ========================================
    */

    if (
        estado ===
        'ENTREGADO'
    ) {

        return {

            tipo:
                'exito',

            etiqueta:
                'Invitación entregada',

            detalle:
                'El servidor de destino confirmó que el email fue entregado correctamente.',

            email,

            mostrarVigencia:
                Boolean(
                    t_inv_restante
                )

        };

    }


    /*
    ========================================
    ENVIADO
    ========================================
    */

    if (
        estado ===
        'ENVIADO' ||

        estado ===
        'ENVIADA'
    ) {

        return {

            tipo:
                'info',

            etiqueta:
                'Invitación enviada',

            detalle:
                'El email ya fue enviado. Estamos esperando la confirmación de entrega del servidor de destino.',

            email,

            mostrarVigencia:
                Boolean(
                    t_inv_restante
                )

        };

    }


    /*
    ========================================
    PENDIENTE / PROGRAMADA
    ========================================
    */

    if (
        estado ===
        'PENDIENTE' ||

        estado ===
        'PROGRAMADA'
    ) {

        return {

            tipo:
                'advertencia',

            etiqueta:
                'Pendiente de envío',

            detalle:
                'La invitación fue creada correctamente y el email se encuentra pendiente de envío.',

            email,

            mostrarVigencia:
                Boolean(
                    t_inv_restante
                )

        };

    }


    /*
    ========================================
    CANCELADO
    ========================================
    */

    if (
        estado ===
        'CANCELADO'
    ) {

        return {

            tipo:
                'neutral',

            etiqueta:
                'Invitación cancelada',

            detalle:
                'Esta invitación ya no se encuentra activa.',

            email,

            mostrarVigencia:
                false

        };

    }


    /*
    ========================================
    ESTADO NO RECONOCIDO
    ========================================
    */

    return {

        tipo:
            'neutral',

        etiqueta:
            'Invitación registrada',

        detalle:
            'Existe un registro de invitación para este paciente.',

        email,

        mostrarVigencia:
            Boolean(
                t_inv_restante
            )

    };

};


const Paciente = () => {

    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [
        config
    ] =
        useConfigAuth();


    /*
    ========================================
    ESTADOS
    ========================================
    */

    const [
        estadoAnamnesis,
        setEstadoAnamnesis
    ] =
        useState(false);


    const [
        estadoObjetivos,
        setEstadoObjetivos
    ] =
        useState(false);


    const [
        estadoHistoriaClinica,
        setEstadoHistoriaClinica
    ] =
        useState(false);


    const [
        estadoActividades,
        setEstadoActividades
    ] =
        useState(false);


    const [
        estadoCantidadSuscripciones,
        setEstadoCantidadSuscripciones
    ] =
        useState(false);


    const [
        hoverMetodo,
        setHoverMetodo
    ] =
        useState(false);


    const [
        verificoEmail,
        setVerificoEmail
    ] =
        useState(false);


    /*
    ========================================
    REDUX
    ========================================
    */

    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const pacientes =
        useSelector(
            state =>
                state.informacion.lista_pacientes ||
                []
        );


    const informacionAnamnesis =
        useSelector(
            state =>
                state.informacion.info_anamnesis ||
                []
        );


    const informacionObjetivos =
        useSelector(
            state =>
                state.informacion.info_objetivos ||
                []
        );


    const informacionHistoriaClinica =
        useSelector(
            state =>
                state.informacion.info_historia_clinica ||
                []
        );


    const informacionActividades =
        useSelector(
            state =>
                state.informacion.info_actividades ||
                []
        );


    const informacionActividadesAgendadas =
        useSelector(
            state =>
                state.informacion.info_actividades_agendadas ||
                []
        );


    const informacionCantidadSuscripciones =
        useSelector(
            state =>
                state.usuario.cantidad_suscripcion ||
                []
        );


    const rol =
        useSelector(
            state =>
                state.usuario.rol
        );


    /*
    ========================================
    PACIENTE SELECCIONADO
    ========================================
    */

    const pacienteSeleccionado =
        pacientes.find(
            item =>
                item.id_paciente ===
                id_paciente
        ) ||
        {};


    const {

        nombre,
        apellido,
        edad,
        mes,
        fecha_nacimiento,
        curso,

        minuscula,
        ayuda_lectura,

        servicio,
        email,

        paciente_id,
        t_inv_restante,
        estado_email_invitacion

    } =
        pacienteSeleccionado;


    /*
    ========================================
    ESTADOS DERIVADOS
    ========================================
    */

    const esUsuarioPrueba =
        servicio ===
        'Usuario Prueba';


    const pruebaFinalizada =
        servicio ===
        'Finalizó Prueba';


    const accesoRestringido =

        esUsuarioPrueba ||

        pruebaFinalizada ||

        verificoEmail;


    const metodoActivo =
        servicio ===
        'Método Yögen';


    /*metodoActivo &&
    Usuario Prueba puede acceder a los
    ejercicios durante el período de prueba,
    aunque el resto de las funciones del
    paciente continúen restringidas.
    */

    const puedeEntrarAEjercicios =

        esUsuarioPrueba ||

        (
            metodoActivo &&
            !accesoRestringido
        );


    /*
    Hoy tu componente tenía isActive=false.

    Lo conservamos:
    calendario e informes previos
    continúan deshabilitados.
    */

    const isActive =
        false;


    const puedeUsarEjercicios =

        String(rol) ===
        '489431' ||

        String(rol) ===
        '935483';


    /*
    ========================================
    ANAMNESIS
    ========================================
    */

    const traerAnamnesis = (
        e
    ) => {

        e.preventDefault();


        if (
            informacionAnamnesis.length ===
            0
        ) {

            const informacion = {

                config,

                payload: {
                    id_paciente
                }

            };


            dispatch(
                solicitarAnamnesisAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoAnamnesis(
                true
            );

        } else {

            navigate(
                '/escritorio/pacientes/paciente/anamnesis'
            );

        }

    };


    /*
    ========================================
    OBJETIVOS
    ========================================
    */

    const traerObjetivos = (
        e
    ) => {

        e.preventDefault();


        if (
            informacionObjetivos.length ===
            0
        ) {

            const informacion = {

                config,

                payload: {
                    id_paciente
                }

            };


            dispatch(
                objetivosSolicitarAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoObjetivos(
                true
            );

        } else {

            navigate(
                '/escritorio/pacientes/paciente/objetivos'
            );

        }

    };


    /*
    ========================================
    HISTORIA CLÍNICA
    ========================================
    */

    const traerHistoriaClinica = (
        e
    ) => {

        e.preventDefault();


        if (
            informacionHistoriaClinica.length ===
            0
        ) {

            const informacion = {

                config,

                payload: {
                    id_paciente
                }

            };


            dispatch(
                historiaClinicaSolicitarAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoHistoriaClinica(
                true
            );

        } else {

            navigate(
                '/escritorio/pacientes/paciente/historiaclinica'
            );

        }

    };


    /*
    ========================================
    ACTIVIDADES
    ========================================
    */

    const traerActividades = (
        e
    ) => {

        e.preventDefault();


        if (
            informacionActividades.length ===
            0
        ) {

            const informacion = {

                config,

                payload: {
                    id_paciente
                }

            };


            dispatch(
                actividadesSolicitarAction(
                    informacion
                )
            );


            dispatch(
                actividadesAgendadasSolicitarAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoActividades(
                true
            );

        } else if (
            informacionActividadesAgendadas.length ===
            0
        ) {

            const informacion = {

                config,

                payload: {
                    id_paciente
                }

            };


            dispatch(
                actividadesAgendadasSolicitarAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoActividades(
                true
            );

        } else {

            navigate(
                '/escritorio/pacientes/paciente/seleccionaractividades'
            );

        }

    };


    /*
    ========================================
    SUSCRIPCIONES
    ========================================
    */

    const traerCantidadSuscripciones = (
        e
    ) => {

        e.preventDefault();


        const informacion = {
            config
        };


        if (
            informacionCantidadSuscripciones.length ===
            0
        ) {

            dispatch(
                solicitoCantidadSuscripcionAction(
                    informacion
                )
            );


            Swal.fire({

                title:
                    'Please Wait',

                showConfirmButton:
                    false

            });


            Swal.showLoading();


            setEstadoCantidadSuscripciones(
                true
            );

        } else {

            navigate(
                '/escritorio/pacientes/paciente/gestionarmetodo'
            );

        }

    };


    /*
    ========================================
    TIPO DE LETRA
    ========================================
    */

    const cambiarMinuscula = (
        e
    ) => {

        e.preventDefault();


        const estado =
            !minuscula;


        const informacion = {

            config,

            payload: {

                id_paciente,

                estado

            },

            info_pacientes: {
                pacientes
            }

        };


        dispatch(
            modificoPacienteMinusculaAction(
                informacion
            )
        );

    };


    /*
    ========================================
    AYUDA LECTURA
    ========================================
    */

    const cambiarLectura = (
        e
    ) => {

        e.preventDefault();


        const estado =
            !ayuda_lectura;


        const informacion = {

            config,

            payload: {

                id_paciente,

                estado

            },

            info_pacientes: {
                pacientes
            }

        };


        dispatch(
            modificoPacienteLecturaAction(
                informacion
            )
        );

    };


    /*
    ========================================
    EFFECT ANAMNESIS
    ========================================
    */

    useEffect(
        () => {

            if (
                estadoAnamnesis
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/anamnesis'
                );


                setEstadoAnamnesis(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionAnamnesis
        ]
    );


    /*
    ========================================
    EFFECT OBJETIVOS
    ========================================
    */

    useEffect(
        () => {

            if (
                estadoObjetivos
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/objetivos'
                );


                setEstadoObjetivos(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionObjetivos
        ]
    );


    /*
    ========================================
    EFFECT HISTORIA
    ========================================
    */

    useEffect(
        () => {

            if (
                estadoHistoriaClinica
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/historiaclinica'
                );


                setEstadoHistoriaClinica(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionHistoriaClinica
        ]
    );


    /*
    ========================================
    EFFECT ACTIVIDADES
    ========================================
    */

    useEffect(
        () => {

            if (
                estadoActividades
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/seleccionaractividades'
                );


                setEstadoActividades(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionActividades
        ]
    );


    useEffect(
        () => {

            if (
                !informacionActividades
            ) {

                return;

            }


            if (
                estadoActividades
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/seleccionaractividades'
                );


                setEstadoActividades(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionActividadesAgendadas
        ]
    );


    /*
    ========================================
    EFFECT SUSCRIPCIONES
    ========================================
    */

    useEffect(
        () => {

            if (
                estadoCantidadSuscripciones
            ) {

                Swal.close();


                navigate(
                    '/escritorio/pacientes/paciente/gestionarmetodo'
                );


                setEstadoCantidadSuscripciones(
                    false
                );

            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            informacionCantidadSuscripciones
        ]
    );


    /*
    ========================================
    EMAIL PRUEBA
    ========================================
    */

    useEffect(
        () => {

            if (
                !email
            ) {

                setVerificoEmail(
                    false
                );


                return;

            }


            const dominio =
                String(email)
                    .split('@')[1];


            setVerificoEmail(
                dominio ===
                'prueba.com'
            );

        },
        [
            email
        ]
    );


    /*
    ========================================
    EDAD PARA MOSTRAR
    ========================================
    */

    const edadTexto =

        edad !==
        undefined &&
        edad !==
        null

            ?
            `${edad} años${
                mes !== undefined &&
                mes !== null
                    ?
                    ` ${mes} meses`
                    :
                    ''
            }`

            :
            'Sin información';


    /*
    ========================================
    INVITACIÓN PARA MOSTRAR
    ========================================
    */

    const infoInvitacion =
        obtenerEstadoInvitacion({

            paciente_id,

            estado_email_invitacion,

            t_inv_restante

        });


    const textoVigencia =

        t_inv_restante !== null &&
        t_inv_restante !== undefined &&
        Number(t_inv_restante) > 0

            ?
            `Invitación vigente por ${
                t_inv_restante
            } ${
                Number(t_inv_restante) === 1
                    ?
                    'hora'
                    :
                    'horas'
            }.`

            :
            null;


    /*
    ========================================
    RENDER
    ========================================
    */

    return (

        <Cuerpo>


            <HeaderUno />


            <HeaderDos

                link="/escritorio/pacientes"

                componente="Información paciente"

                paciente={true}

            />


            <PaginaPaciente>


                <GridPaciente>


                    {/* =====================================
                        COLUMNA IZQUIERDA
                    ====================================== */}

                    <ColumnaResumen>


                        <TarjetaPaciente>


                            {/* =============================
                                DATOS DEL PACIENTE
                            ============================== */}

                            <CabeceraTarjetaPaciente>


                                <BloqueTituloPaciente>


                                    <TituloTarjetaPaciente>

                                        Datos del paciente

                                    </TituloTarjetaPaciente>


                                    <TextoTarjetaPaciente>

                                        Información principal
                                        de su perfil.

                                    </TextoTarjetaPaciente>


                                </BloqueTituloPaciente>


                                {
                                    accesoRestringido
                                        ?
                                        (

                                            <BotonEditarPacienteDeshabilitado>

                                                Editar perfil

                                            </BotonEditarPacienteDeshabilitado>

                                        )
                                        :
                                        (

                                            <BotonEditarPaciente

                                                to="/escritorio/pacientes/paciente/datos"

                                            >

                                                Editar perfil

                                            </BotonEditarPaciente>

                                        )
                                }


                            </CabeceraTarjetaPaciente>


                            <DatosPaciente>


                                <DatoPaciente>


                                    <LabelDatoPaciente>

                                        Nombre

                                    </LabelDatoPaciente>


                                    <ValorDatoPaciente>

                                        {
                                            nombre ||
                                            'Sin información'
                                        }

                                    </ValorDatoPaciente>


                                </DatoPaciente>


                                <DatoPaciente>


                                    <LabelDatoPaciente>

                                        Apellido

                                    </LabelDatoPaciente>


                                    <ValorDatoPaciente>

                                        {
                                            apellido ||
                                            'Sin información'
                                        }

                                    </ValorDatoPaciente>


                                </DatoPaciente>


                                <DatoPaciente $completo>


                                    <LabelDatoPaciente>

                                        Edad

                                    </LabelDatoPaciente>


                                    <ValorDatoPaciente>

                                        {
                                            edadTexto
                                        }

                                    </ValorDatoPaciente>


                                </DatoPaciente>


                                <DatoPaciente>


                                    <LabelDatoPaciente>

                                        Fecha de nacimiento

                                    </LabelDatoPaciente>


                                    <ValorDatoPaciente>

                                        {
                                            fecha_nacimiento ||
                                            'Sin información'
                                        }

                                    </ValorDatoPaciente>


                                </DatoPaciente>


                                <DatoPaciente>


                                    <LabelDatoPaciente>

                                        Curso

                                    </LabelDatoPaciente>


                                    <ValorDatoPaciente>

                                        {
                                            curso ||
                                            'Sin información'
                                        }

                                    </ValorDatoPaciente>


                                </DatoPaciente>


                            </DatosPaciente>


                            {/* =============================
                                ESTADO INVITACIÓN
                            ============================== */}

                            <BloqueInvitacion

                                $tipo={
                                    infoInvitacion.tipo
                                }

                            >


                                <CabeceraInvitacion>


                                    <TituloInvitacion>

                                        Invitación a la plataforma

                                    </TituloInvitacion>


                                    <EstadoInvitacion

                                        $tipo={
                                            infoInvitacion.tipo
                                        }

                                    >

                                        {
                                            infoInvitacion.etiqueta
                                        }

                                    </EstadoInvitacion>


                                </CabeceraInvitacion>


                                {
                                    infoInvitacion.email && (

                                        <EmailInvitacion>

                                            {
                                                infoInvitacion.email
                                            }

                                        </EmailInvitacion>

                                    )
                                }


                                <TextoInvitacion>

                                    {
                                        infoInvitacion.detalle
                                    }

                                </TextoInvitacion>


                                {
                                    infoInvitacion.mostrarVigencia &&
                                    textoVigencia && (

                                        <VigenciaInvitacion>

                                            {
                                                textoVigencia
                                            }

                                        </VigenciaInvitacion>

                                    )
                                }


                            </BloqueInvitacion>


                            {/* =============================
                                SEPARADOR
                            ============================== */}

                            <SeparadorPaciente />


                            {/* =============================
                                MÉTODO YÖGEN
                            ============================== */}

                            {
                                accesoRestringido
                                    ?
                                    (

                                        <BotonMetodo
                                            type="button"
                                            $deshabilitado
                                        >

                                            Desactivar Método YÖGEN

                                        </BotonMetodo>

                                    )
                                    :
                                    metodoActivo
                                        ?
                                        (

                                            <BotonMetodoLink

                                                to="/escritorio/pacientes/paciente/gestionarmetodo"

                                            >

                                                Desactivar Método YÖGEN

                                            </BotonMetodoLink>

                                        )
                                        :
                                        (

                                            <BotonMetodo

                                                type="button"

                                                onClick={
                                                    traerCantidadSuscripciones
                                                }

                                            >

                                                Activar Método YÖGEN

                                            </BotonMetodo>

                                        )
                            }


                            {/* =============================
                                CONFIGURACIÓN
                            ============================== */}

                            <ConfiguracionInferior>


                                <ConfiguracionInlineItem>


                                    <ConfiguracionInlineLabel>

                                        Tipo de letra

                                    </ConfiguracionInlineLabel>


                                    <BotonConfiguracion

                                        type="button"

                                        onClick={
                                            cambiarMinuscula
                                        }

                                    >

                                        {
                                            minuscula
                                                ?
                                                'Minúscula'
                                                :
                                                'Mayúscula'
                                        }

                                    </BotonConfiguracion>


                                </ConfiguracionInlineItem>


                                <ConfiguracionInlineItem>


                                    <ConfiguracionInlineLabel>

                                        Ayuda color

                                    </ConfiguracionInlineLabel>


                                    <BotonConfiguracion

                                        type="button"

                                        onClick={
                                            cambiarLectura
                                        }

                                    >

                                        {
                                            ayuda_lectura
                                                ?
                                                'Activa'
                                                :
                                                'Inactiva'
                                        }

                                    </BotonConfiguracion>


                                </ConfiguracionInlineItem>


                            </ConfiguracionInferior>


                        </TarjetaPaciente>


                    </ColumnaResumen>


                    {/* =====================================
                        COLUMNA DERECHA
                    ====================================== */}

                    <TarjetaPaciente>


                        <CabeceraTarjetaPaciente>


                            <BloqueTituloPaciente>


                                <TituloTarjetaPaciente>

                                    Accesos del paciente

                                </TituloTarjetaPaciente>


                                <TextoTarjetaPaciente>

                                    Historia, evaluación,
                                    planificación y actividades.

                                </TextoTarjetaPaciente>


                            </BloqueTituloPaciente>


                        </CabeceraTarjetaPaciente>


                        <GridAccesos>


                            {/* ANAMNESIS */}

                            <BotonAcceso

                                type="button"

                                $deshabilitado={
                                    accesoRestringido
                                }

                                onClick={
                                    accesoRestringido
                                        ?
                                        undefined
                                        :
                                        traerAnamnesis
                                }

                            >

                                Anamnesis

                            </BotonAcceso>


                            {/* RESULTADOS */}

                            {
                                accesoRestringido
                                    ?
                                    (

                                        <BotonAcceso
                                            type="button"
                                            $deshabilitado
                                        >

                                            Resultados

                                        </BotonAcceso>

                                    )
                                    :
                                    (

                                        <BotonAccesoLink

                                            to="/escritorio/pacientes/paciente/resultados"

                                        >

                                            Resultados

                                        </BotonAccesoLink>

                                    )
                            }


                            {/* HISTORIA CLÍNICA */}

                            <BotonAcceso

                                type="button"

                                $deshabilitado={
                                    accesoRestringido
                                }

                                onClick={
                                    accesoRestringido
                                        ?
                                        undefined
                                        :
                                        traerHistoriaClinica
                                }

                            >

                                Historia clínica

                            </BotonAcceso>

                            {/* OBJETIVOS */}

                            <BotonAcceso

                                type="button"

                                $deshabilitado={
                                    accesoRestringido
                                }

                                onClick={
                                    accesoRestringido
                                        ?
                                        undefined
                                        :
                                        traerObjetivos
                                }

                            >

                                Objetivos

                            </BotonAcceso>


                            {/* EJERCITACIÓN DOMICILIO */}

                            <BotonAcceso

                                type="button"

                                $deshabilitado={
                                    accesoRestringido ||
                                    !metodoActivo
                                }

                                onClick={
                                    !accesoRestringido &&
                                    metodoActivo
                                        ?
                                        traerActividades
                                        :
                                        undefined
                                }

                                onMouseEnter={() => {

                                    if (
                                        !metodoActivo &&
                                        !accesoRestringido
                                    ) {

                                        setHoverMetodo(
                                            true
                                        );

                                    }

                                }}

                                onMouseLeave={() =>
                                    setHoverMetodo(
                                        false
                                    )
                                }

                            >

                                Ejercitación domicilio

                            </BotonAcceso>


                            {/* EJERCICIOS */}

                            {
                                puedeUsarEjercicios
                                    ?
                                    (

                                        <BotonAccesoLink

                                            to={
                                                puedeEntrarAEjercicios
                                                    ?
                                                    '/escritorio/metodos'
                                                    :
                                                    '#'
                                            }

                                            $deshabilitado={
                                                !puedeEntrarAEjercicios
                                            }

                                            onMouseEnter={() => {

                                                if (
                                                    !metodoActivo &&
                                                    !accesoRestringido
                                                ) {

                                                    setHoverMetodo(
                                                        true
                                                    );

                                                }

                                            }}

                                            onMouseLeave={() =>
                                                setHoverMetodo(
                                                    false
                                                )
                                            }

                                        >

                                            Ejercicios

                                        </BotonAccesoLink>

                                    )
                                    :
                                    (

                                        <TextoNoSuscripto>

                                            Profesional no suscripto

                                        </TextoNoSuscripto>

                                    )
                            }


                            {/* ESTADÍSTICAS */}

                            {
                                String(rol) ===
                                '489431' && (

                                    <AccesoAncho>


                                        <BotonAccesoLink

                                            to="/escritorio/pacientes/paciente/estadisticas"

                                        >

                                            Estadísticas y cobros

                                        </BotonAccesoLink>


                                    </AccesoAncho>

                                )
                            }


                        </GridAccesos>


                        {
                            hoverMetodo &&
                            !metodoActivo && (

                                <AvisoMetodo>

                                    Debés activar Método YÖGEN
                                    para utilizar estas funciones.

                                </AvisoMetodo>

                            )
                        }


                    </TarjetaPaciente>


                </GridPaciente>


            </PaginaPaciente>


        </Cuerpo>

    );

};


export default Paciente;